import type { ActiveAutoshipSubscription } from '@libs/common-types';
import { getAutoshipCadenceByValue } from '@libs/common-types';

import type { ProductPromotion } from '../types';
import { AutoShipUnitOfMeasure } from '../types';

export const getFrequencyInWeeks = (frequency: number, unitOfMeasure: AutoShipUnitOfMeasure): number => {
    switch (unitOfMeasure) {
        case AutoShipUnitOfMeasure.Days:
            return Math.ceil(frequency / 7);
        case AutoShipUnitOfMeasure.Months:
            return frequency * 4;
        default:
            return frequency; // default to number of weeks
    }
};

export const getUomByValue = (numericUnitOfMeasure: number): AutoShipUnitOfMeasure => {
    switch (numericUnitOfMeasure) {
        case 1:
            return AutoShipUnitOfMeasure.Days;
        case 3:
            return AutoShipUnitOfMeasure.Months;
        default:
            return AutoShipUnitOfMeasure.Weeks;
    }
};

export const formatAutoshipFrequency = (frequency?: number | null, unitOfMeasure?: number | null): string | null => {
    if (!frequency || !unitOfMeasure) {
        return null;
    }

    const value = `${frequency}_${unitOfMeasure}`;
    const cadence = getAutoshipCadenceByValue(value);

    return cadence?.label ?? null;
};

export const GetAutoshipPromo = (promotions: ProductPromotion[]) =>
    promotions?.filter(promo => promo.isAutoShipPromotion)?.[0];

export function getActiveAutoshipSkuSet(activeSubscriptions: ActiveAutoshipSubscription[]): Set<string> {
    return new Set(activeSubscriptions.map(({ sku }) => sku));
}
